export const OPEN_CHAT_TITLE = 'Онлайн чат';

// eslint-disable-next-line
export enum JivoMobileButtonClass {
    Default = 'jivo-widget-position-mobile_default',
    HighOffset = 'jivo-widget-position-mobile_high-offset',
}
